const products = {
    products: {
        HaifaStimBooster: "Steigert die Stoffwechselaktivität in Stresssituationen",
        HaifaStimEnergy: "Verbessert die Energiebilanz der Pflanze",
        HaifaStimForce: "Spart Stoffwechselenergie: unterstützt die Aminosäure- und Proteinsynthese",
        HaifaStimHumiK: "Unterstützt die Wurzelaktivität und Aufnahme von Nährstoffen",
        HaifaStimVigor: "Stärkung und Verbesserung der Pflanzenresistenz gegenüber abiotischem Stress",
        HaifaStimVIM: "Verbessert die Bodenfruchtbarkeit und die Effizienz der Nährstoffnutzung",
        HaifaStimVital: "Verbessert die Pflanzenleistung",
        HaifaStimWallUp:
            "Optimale Mischung ausgewählter Mikronährstoffe zur Verbesserung der Pflanzenresistenz gegenüber abiotischem Stress: zur Steigerung des Wachstums und zur Maximierung des Ertrags",
        HaifaMicroCombi:
            "Eine stabile: wasserlösliche und nicht staubende Mischung aus Metallchelaten: Eisen: Mangan: Kupfer: Zink - alle liegen als EDTA-chelierte Form vor",
        PolyFeedFoliar1:
            "Poly-Feed™ Foliar nährt Pflanzen und erfüllt ihre genauen Bedürfnisse während kritischer Wachstumsphasen für maximale Erträge und Spitzenqualität.",
        PolyFeedFoliar2: "Artenspezifische Formel",
        PolyFeedStim: "einzigartige Kombination aus natürlichen Wachmachern und mineralischen NPK-Düngern",
        HaifaBonus:
            "Die Formulierungen von Düngemitteln mit hohem Kaliumgehalt für eine effiziente Blattapplikation basieren auf Multi-K™ Kaliumnitrat von Haifa.",
    },
};

export default products;
